var MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
var wheel = {
	beforeCount : 0,
	count 		: 0,
	scrollCount	: 0,
	max 		: 0,
	canScroll 	: true,
	normalScroll: false,
	canMove : true,//連続してcountを上げ下げ出来ないようにするためのフラグ
	inc: function(){
		if(wheel.canMove){
			wheel.count++;
			if(wheel.count > wheel.max){
				wheel.count = wheel.max;
				wheel.normalScroll 	= true;
			}else{
				wheel.normalScroll = false;
				wheel.move();
			}
		}
	},
	dec: function(){
		if(wheel.canMove){
			wheel.count--;
			if(wheel.count < 0){
				wheel.count = 0;
				wheel.canMove 		= true;
				wheel.canScroll 	= true;
			}else{
				wheel.move();
			}
			wheel.normalScroll = false;
		}
	},
	move 	: function(){
		if(wheel.canMove){
			wheel.canMove = false;
			if(wheel.count != wheel.max){
				wheel.notMax();
			}
			if(wheel.count < wheel.beforeCount){
				webgl.prevState(1);
			}else{
				if(wheel.count === 1){
					webgl.nextState(1.5);
				}else{
					webgl.nextState(1);
				}
			}
			$("#wrap").off();
			let html = document.documentElement;
			let cls = "active" + wheel.count;
			setTimeout(function(){
				for(var i = 0; i < wheel.max+1; i++){
					let cls = "active" + i;
					if($html.classList.contains(cls)){
						$html.classList.remove(cls);
					}
				}
				$html.classList.add(cls);
				if(wheel.count === wheel.max){
					wheel.isMax();
				}else{
					home.nav();
					setTimeout(function(){
						wheel.normalScroll = false;
					}, 300);
				}
				setTimeout(function(){
					var $blk = $(".block").eq(wheel.count);
					if(!$blk.hasClass("active")){
						$(".block").eq(wheel.count).addClass("active");
					}
				},600);
				setTimeout(function(){
					wheel.beforeCount = wheel.count;
					wheel.canScroll = true;
					wheel.canMove 	= true;
				}, 1500);
			},50);
		}
	},
	notMax: function(){
		wheel.canScroll = false;
		if($html.classList.contains("scrl")){
			$html.classList.remove("scrl");
			$html.classList.remove("btm");
		}
	},
	isMax: function(){
		wheel.scrollCount 	= 0;
		wheel.canScroll 	= true;
		wheel.canMove 		= true;
		$html.classList.add("btm");
		if(isSmallScreen){
			home.spScroll();
			$("#block_btm").off().on(transitionEnd, function(){
				$("#block_btm").off();
			});
		}else{
			home.nav();
		}
		setTimeout(function(){
			$html.classList.add("scrl");
		},500);
	}
}
var home = {
	init: function(){
		if(page.isPage != "home"){
			return false
		}else{
			home.resize();
			home.nav();
			wheel.count = 0;
			wheel.max 	= $(".block").length;
		}
	},
	resize: function(){
		let winH = $(window).height();
		let productH 	= "",
			minH 		= 640;
		if(isSmallScreen){
			productH = "";
		}else{
			productH = winH < minH ? minH : winH + "px";
		}
		$("#block_product").css({
			"height" : productH
		});
	},
	spScroll: function(){
		let $body = $("body"),
			limit = 0;

		if(isSP){
			limit = -50;
		}else{
			limit = 0;
		}
		var lastTouchY = lastTouchY || 0,
			positionY,cy, isOver, topD;
		$("#block_scroll").off().on({
			'touchstart': function(e) {
				cy 			= 0;
				positionY 	= getPosition(e);
			},
			'touchmove': function(e) {
				if(!wheel.canScroll){ 
					return false;
				}else{
					cy 	= positionY - getPosition(e);
					if(cy < 0){
						e.preventDefault();
						wheel.canScroll = false;
						if($html.classList.contains("btm")){
							$html.classList.remove("btm");
							wheel.count = wheel.max - 1;
							//webgl.prevState(1);
							wheel.move();
						}
					}
				}
			}
		})
		function getPosition(event){
			return event.touches[0].pageY;
		}
	},
	reset: function(){
		wheel.canScroll = true;
		wheel.count = 0;
		wheel.beforeCount = 0;
		wheel.move();
		common.scrollToPosition(0);
	},
	nav: function(){
		var isFired = false;
		if(isSP || isIPad){
			var lastTouchY = lastTouchY || 0,
				positionY,cy, isOver, topD,
				limit = 80;
			$("#wrap").off().on({
				'touchstart': function(e) {
					cy 			= 0;
					positionY 	= getPosition(e);
				},
				'touchmove': function(e) {
					e.preventDefault();
					if(!wheel.canScroll){ 
						return false;
					}else{
						cy 	= positionY - getPosition(e);
					}
				},
				'touchend': function(e) {
					positionY = 0;
					if(wheel.canScroll){
						wheel.canScroll = false;
						if(cy <= -limit){
							if(wheel.count === wheel.max-1){
								wheel.count = wheel.max-2;
							}else{
								wheel.count--;
								if(wheel.count < 0){
									wheel.count = 0;
								}
							}
							wheel.move();
						}else if(cy > limit){
							if(wheel.count < wheel.max){
								wheel.count++;
							}
							wheel.move();
						}else{
							cy = 0;
							wheel.canScroll = true;
						}
					}
					
				},
				'touchcancel': function(e){
					cy = 0;
					wheel.canScroll = true;
				}
			});
		}else{
			var callback = function (delta) {
				if(delta >= 1) {
					delta = 0;
					setTimeout(function(){
						wheel.dec();
					},100);
				}else if(delta < 0){
					delta = 0;
					setTimeout(function(){
						wheel.inc();
					},100);
				}else{
					wheel.canScroll = true;
				}
			};
			wheel.canScroll = true;
			
			// キャッシュ
			callback.delta = 0;
			callback.timeStamp = Date.now();
			//document.removeEventListener(MOUSE_WHEEL_EVENT, changeDelta, false);
			//document.addEventListener(MOUSE_WHEEL_EVENT, changeDelta, false);
			$(document).off(MOUSE_WHEEL_EVENT).on(MOUSE_WHEEL_EVENT, function(e){
				changeDelta(e);
			});
			
			var interval = 250;
			var last_time = 0,
				delta = 0,
				uintDelta = 0;
			callback.delta = 0;
			
			function changeDelta(e){
				if(wheel.count === wheel.max){
					getDelta(e);
				}else{
					getTopdelta(e);
				}
			}
			function getTopdelta(e){
				if(wheel.normalScroll){
					wheel.canScroll = true;
				}else{
					if(!wheel.canScroll){ return false}
					var now = new Date().getTime();
					var diff = now - last_time;
					/*
					chromeのconsoleでエラーが出るため、削除 2019.05.09
					e.preventDefault();
					*/
					delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
					//console.log(delta)

					if (!delta) { return;}
					uintDelta = Math.abs(delta);
					if (uintDelta - callback.delta > 0) {
						//増加
						if (diff > interval && !isFired){
							callback(delta);
							isFired = true;
						}
						last_time = now;
					}else{
						//減退
						isFired = false;
					}
					callback.delta = uintDelta;
				}
			}
		}

		//スクロールエリア用 ----------------------------------
		wheel.scrollCount = 0;
		let canScroll = true;
		var callback02 = function (delta) {
			if($(document).scrollTop() <= 0){
				if(delta >= 1) {
					if(wheel.canScroll){
						delta = 0;
						wheel.canScroll = false;
						wheel.count 	= wheel.max -1;
						//webgl.prevState(1);
						wheel.move();
					}
				}
			}else{
				canScroll = true;
			}
		};
		var lasttime02 = 0;
		function getDelta(e){
			var now 	= new Date().getTime();
			var diff 	= now - last_time;
			delta 		= e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail); 
			if (!delta) { return;}
			uintDelta = Math.abs(delta);
			if(delta >= 1) {
				if($(document).scrollTop() <= 0){
					if(wheel.canScroll && wheel.count === wheel.max){
						delta = 0;
						wheel.canScroll = false;
						wheel.count 	= wheel.max -1;
						//webgl.prevState(1);
						wheel.move();
					}
				}
			}
			callback.delta = uintDelta;
		}
		function getPosition(event){
			return event.touches[0].pageY;
		}
	}
}